var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [!_vm.hideBuyer ? _c('v-card', {
    staticClass: "mb-8 pa-4",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('invoice-party-form', {
    ref: "buyerForm",
    attrs: {
      "partnerId": _vm.value.partnerId,
      "readonly": true,
      "title": _vm.$t('objects.invoice.buyer')
    },
    model: {
      value: _vm.value.buyer,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "buyer", $$v);
      },
      expression: "value.buyer"
    }
  })], 1) : _vm._e(), !_vm.value.buyer ? _c('company-selection', {
    model: {
      value: _vm.buyerCompany,
      callback: function callback($$v) {
        _vm.buyerCompany = $$v;
      },
      expression: "buyerCompany"
    }
  }) : _vm._e(), _vm.readonly ? _c('v-card', {
    staticClass: "mb-8 pa-4",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('invoice-party-form', {
    ref: "sellerForm",
    attrs: {
      "partnerId": _vm.value.partnerId,
      "readonly": _vm.readonly,
      "title": _vm.$t('objects.invoice.seller')
    },
    model: {
      value: _vm.value.seller,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "seller", $$v);
      },
      expression: "value.seller"
    }
  })], 1) : _c('company-selection', {
    model: {
      value: _vm.sellerCompany,
      callback: function callback($$v) {
        _vm.sellerCompany = $$v;
      },
      expression: "sellerCompany"
    }
  }), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    attrs: {
      "label": _vm.$t('objects.invoice.seller'),
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.seller,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "seller", $$v);
      },
      expression: "value.seller"
    }
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('objects.invoice.type') + ' *',
      "items": _vm.invoiceTypes,
      "outlined": "",
      "id": "invoiceType"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(" " + _vm._s(_vm.$t("enums.InvoiceTypeEnum.".concat(item))))])];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(" " + _vm._s(_vm.$t("enums.InvoiceTypeEnum.".concat(item))))])];
      }
    }]),
    model: {
      value: _vm.value.type,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "type", $$v);
      },
      expression: "value.type"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$t('objects.repairEstimate.currency'),
      "clearable": "",
      "outlined": "",
      "return-object": "",
      "auto-select-first": "",
      "items": Object.values(_vm.CurrencyEnum),
      "filter": _vm.getAutocompleteFilter(function (e) {
        return [e];
      }),
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "currency", $$v);
      },
      expression: "value.currency"
    }
  })], 1)], 1), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoice.number') + ' *',
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.number,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "number", $$v);
      },
      expression: "value.number"
    }
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoice.date') + ' *',
      "outlined": "",
      "type": "date",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.dateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "dateFormable", $$v);
      },
      expression: "value.dateFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoice.due') + ' *',
      "outlined": "",
      "type": "date",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.dueFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "dueFormable", $$v);
      },
      expression: "value.dueFormable"
    }
  })], 1)], 1), _c('line-items-form', {
    attrs: {
      "accountingType": _vm.AccountingTypeEnum.EXPENSE,
      "coverageType": _vm.coverageType
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }